/* @ngInject */
function GuestAssetCardController (
  $scope,
  RepositoryService,
  Utils,
  NewAssetService,
  AssetService,
  SegmentService,
  AssetPreviewService
) {
  const ctrl = this

  const api = {
    _handleAssetData,
    _getAssetSize,
    _setAssetThumbnailSrc,
    _checkAssetHasThumbnail,
    _waitAssetThumbnail
  }
  this.getApi = () => api
  activate()
  function activate () {}

  const deregisterAssetWatcher = $scope.$watch('$ctrl.asset', newValue => {
    if (!newValue) return
    api._handleAssetData()
  })

  $scope.$on('$destroy', function () {
    deregisterAssetWatcher()
  })

  function _handleAssetData () {
    api._setAssetThumbnailSrc()
    api._checkAssetHasThumbnail().then(hasThumbnail => {
      if (!hasThumbnail) {
        api._waitAssetThumbnail()
      }
    })

    ctrl.assetIcon = RepositoryService.defineAssetIconBasedOnExtension(ctrl.asset)
  }

  function _checkAssetHasThumbnail () {
    return NewAssetService.checkAssetHasThumb(ctrl.asset.id, 'LOW')
  }

  function _waitAssetThumbnail () {
    NewAssetService.waitAssetThumbnail({
      assetId: ctrl.asset.id,
      quality: 'LOW'
    }).then(() => {
      const forceRefresh = true
      api._setAssetThumbnailSrc(forceRefresh)
    })
  }

  function _setAssetThumbnailSrc (forceRefresh = false) {
    const { thumbnail, default: defaultThumb } = ctrl.asset.src
    const url = thumbnail || defaultThumb
    if (!forceRefresh) {
      ctrl.assetThumbnailSrc = url
      return
    }

    ctrl.assetThumbnailSrc = Utils.fnAddQueryToUrl(url, { date: new Date().getTime() })
    $scope.$apply()
  }

  function _getAssetSize (asset) {
    if (asset.size) {
      return Utils.getReadableFileSizeString(asset.size)
    }
  }

  $scope.handleOpenPreviewAsset = event => {
    event.stopPropagation()
    $scope.openPreview()
  }

  $scope.openPreview = () => {
    if (AssetPreviewService.assetPreviewIsOpen()) {
      return
    }

    AssetPreviewService.openAssetPreview({
      asset: ctrl.asset,
      location: 'guests',
      getPreviewAssets: () => {
        return Promise.resolve({
          assets: [],
          count: 0
        })
      }
    })
  }

  $scope.handleDownloadAsset = event => {
    event.stopPropagation()
    const assetId = ctrl.asset.id
    AssetService.downloadAsset(assetId).then(() => {
      SegmentService.track('downloaded-file', {
        asset_pack_id: ctrl.assetPackId,
        asset_id: assetId
      })
    })
  }

  $scope.handleSelect = event => {
    event.stopPropagation()
    if (ctrl.onSelect) ctrl.onSelect()
  }
}

export { GuestAssetCardController }
